import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { DataTestDirective } from '@mkp/tracking/feature-tracking';
import { TranslateModule } from '@ngx-translate/core';
import { MaskPiiDirective } from '../../../directives/mask-pii/mask-pii.directive';
import { InputWrapperModule } from '../input-wrapper/input-wrapper.module';
import { SelectComponent } from './select.component';
import { AssetComponent } from '@mkp/shared/ui-asset';

@NgModule({
  imports: [
    InputWrapperModule,
    CommonModule,
    MatSelectModule,
    TranslateModule,
    ReactiveFormsModule,
    DataTestDirective,
    MaskPiiDirective,
    AssetComponent,
  ],
  exports: [SelectComponent],
  declarations: [SelectComponent],
})
export class SelectModule {}
